import * as Sentry from "@sentry/react"
import { message, useTheme } from "@mimber/ui-web"
import type { UseReportIssueFeedbackReturn } from "./useReportIssueFeedback.types"

/**
 * Opens the Sentry user feedback (bug report) form. Shows a fallback message
 * if the feedback integration is unavailable (e.g. Sentry disabled in dev/test).
 */
export const useReportIssueFeedback = (): UseReportIssueFeedbackReturn => {
  const { isDark } = useTheme()

  const openReportIssueForm = async () => {
    const feedback = Sentry.getFeedback()
    if (!feedback) {
      message.warning(
        "Reporting an issue isn't available right now. Please try again later."
      )
      return
    }

    // Match the widget to the user's selected theme rather than OS preference
    const form = await feedback.createForm({
      colorScheme: isDark ? "dark" : "light",
    })
    form.appendToDom()
    form.open()
  }

  return { openReportIssueForm }
}
